export default __webpack_public_path__ + "static/media/2494.7cb2e35b.png";